import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop, Emit } from 'vue-property-decorator';

@Component({
})
export default class OrderSortPanel extends Vue {
    @Prop({default: 'grid'}) viewListMode!: 'grid' | 'list'
    sortBy = {
        viewName: 'Дате (сначала новые)',
        name: 'date_desc',
    }
    sortList = [
        {
            viewName: '№ Заказа (по возрастанию)',
            name: 'order_number_asc',
        },
        {
            viewName: '№ Заказа (по убыванию)',
            name: 'order_number_desc',
        },
        {
            viewName: 'Дате (сначала новые)',
            name: 'date_desc',
        },
        {
            viewName: 'Дате (сначала старые)',
            name: 'date_asc',
        },
    ]

    @Watch('sortBy') onSortByChanged() {
        this.$emit('sort', this.sortBy.name)
    }
    @Emit('update:viewListMode') viewListModeChange(e: 'grid' | 'list') {
        return e
    }
}